export default {
  CONTACT_FIELD: 1,
  CUSTOM_FIELD: 2,
  ADDRESS_FIELD: 3,
};
